import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { Button } from './ui/button';
import { toast } from 'sonner';
import { copyText } from '../lib/clipboard';

export const CopyValue = ({ label, value, testId }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try { await copyText(value); setCopied(true); toast.success(`${label} copied`); }
    catch { toast.error('Could not copy. Select and copy the value manually.'); }
  };
  return <div className="space-y-1"><p className="text-xs text-slate-500">{label}</p><div className="flex items-center gap-3 min-w-0"><code data-testid={testId} className="break-all flex-1 select-all text-sm">{value}</code><Button type="button" size="icon" variant="outline" data-testid={`${testId}-copy`} aria-label={`Copy ${label.toLowerCase()}`} title={`Copy ${label.toLowerCase()}`} onClick={copy}>{copied ? <Check size={16} /> : <Copy size={16} />}</Button></div></div>;
};